const pages = {
    "menu_item_main": "Home page",
    "menu_item_sms": "SMS",
    "menu_item_sms_clients_routing": "SMS clients routing and tariffication",
    "menu_item_sms_provider_routing": "SMS service providers routing and tariffication",
    "menu_item_sms_pool_rules": "Changing the sender\"s address",
    "menu_item_sms_filter": "SMS text filters",
    "menu_item_sms_filter_all_partners": "General rules for blockingSMS by text",
    "menu_item_sms_set_priority": "Changing the priority",
    "menu_item_sms_duplicate": "Blocking the same messages",
    'menu_item_sms_templates':'Templates',
    'menu_item_sms_originators':'Originator address restrictions',
    "menu_item_settings_duplicate": "Blocking the same messages",
    "menu_item_call": "Calls",
    "menu_item_call_sounds": "Collection of sounds",
    "menu_item_call_ivr": "IVR menu",
    "menu_item_call_templates": "Templates",
    'menu_item_call_clients_routing':'Call clients tariffication',
    'menu_item_call_provider_routing':'Call service providers tariffication',
    "menu_item_call_pool_rules": "Change sender address",
    "menu_item_call_services": "Services",
    "menu_item_email": "Email",
    "menu_item_email_route": "Email routing and charging",
    'menu_item_email_clients_tariff':'Email clients tariffication',
    'menu_item_email_provider_tariff':'Email service providers tariffication',
    "menu_item_email_templates": "Templates",
    'menu_item_email_tariff':'Tariffication',
    'menu_item_statistics_email_events_group':'Email events group statistics',
    "menu_item_user_manage": "User</br>management",
    "menu_item_user_manage_user_partners": "Partner accounts",
    "menu_item_user_manage_user_system": "System users",
    "menu_item_user_manage_user_role": "Roles",
    'menu_item_user_manage_user_partners_role': 'Client accounts roles',
    "menu_item_user_manage_user_logs": "User actions",
    'menu_item_user_manage_system_actions':'User actions logging settings',
    'menu_item_user_manage_user_cc':'Call center users',
    "menu_item_settings_black_list": "Black lists",
    "menu_item_settings_general_black_list": "General black lists",
    "menu_item_user_manage_template_moderation": "Template Moderation",
    "menu_item_settings": "Settings",
    "menu_item_settings_accounts": "Accounts",
    "menu_item_settings_providers": "Service providers",
    "menu_item_settings_clients": "Clients",
    "menu_item_settings_senders": "Sender addresses",
    "menu_item_settings_cms": "System settings",
    "menu_item_user_manage_distr": "Moderation",
    "menu_item_settings_operator_smpp": "Connections to operators by SMPP",
    "menu_item_settings_pool": "Number Pools",
    "menu_item_settings_message_types": "Message types",
    "menu_item_settings_additional_rules": "Additional rules",
    'menu_item_settings_templates_params':'Additional template parameters',
    'menu_item_settings_set_priority':'Change priority',
    "menu_item_statistics": "Statistics",
    "menu_item_statistics_export_reports": "Export report",
    "menu_item_lcr_check": "LCR routing check",
    "menu_item_settings_logica_smpp": "Service Provider Connections",
    "menu_item_settings_server_smpp": "Partners Connections",
    "menu_item_statistics_sms_detail": "Detailed SMS statistics",
    "menu_item_statistics_sms_group": "GroupSMS statistics",
    "menu_item_statistics_sms_mo_detail": "Detailed inboundSMS statistics",
    "menu_item_statistics_sms_mo_group": "Group inboundSMS statistics",
    "menu_item_statistics_email_detail": "DetailEmail statistics",
    "menu_item_statistics_email_group": "GroupEmail statistics",
    "menu_item_statistics_call_detail": "Detailed call statistics",
    "menu_item_statistics_call_mo_detail": "Detailed incoming call statistics",
    "menu_item_statistics_call_group": "Group call statistics",
    "menu_item_statistics_call_mo_group": "Group incoming call statistics",
    "menu_item_statistics_push_detail": "Push detail statistics",
    "menu_item_statistics_push_group": "Push group statistics",
    "menu_item_statistics_ussd_group": "USSD group statistics",
    "menu_item_statistics_ussd_detail": "USSD detail statistics",
    "menu_item_statistics_viber_group": "Viber group Statistics",
    "menu_item_statistics_viber_detail": "Viber detail statistics",
    'menu_item_viber_mo_routing':'Incoming message routing',
    'menu_item_statistics_viber_mo_detail':"Detailed incoming Viber statistics",
    'menu_item_statistics_viber_mo_group':"Group incoming Viber statistics",
    "menu_item_statistics_export": "Export reports",
    "menu_item_login": "Authentication",
    "menu_item_push": "Push",
    'menu_item_push_clients_tariff':'Push clients tariffication',
    "menu_item_push_applications": "Manage applications",
    "menu_item_push_app_attribute": "Application Attributes",
    "menu_item_push_subscribers": "Number of subscribers",
    "menu_item_push_history": "Subscription history",
    "menu_item_push_tariff": "Tariffication",
    "menu_item_push_templates": "Templates",
    "menu_item_ussd": "USSD",
    "menu_item_ussd_menu": "USSD menu",
    'menu_item_ussd_clients_routing':'USSD clients routing and tariffication',
    'menu_item_ussd_provider_routing':'USSD service providers routing and tariffication',
    "menu_item_ussd_routing": "Routing incoming USSD requests",
    "menu_item_ussd_templates": "Templates",
    "menu_item_viber": "Viber",
    'menu_item_viber_clients_tariff':'Тарификация Viber клиентов',
    'menu_item_viber_provider_tariff':'Тарификация Viber поставщиков услуг',
    "menu_item_viber_templates": "Templates",
    "menu_item_whatsapp":'WhatsApp',
    "menu_item_whatsapp_templates":'Templates',
    "menu_item_statistics_whatsapp_detail":'WhatsApp detail statistics',
    "menu_item_statistics_whatsapp_group":'WhatsApp group statistics',
    'menu_item_whatsapp_clients_tariff':"WhatsApp clients tariffication",
    'menu_item_whatsapp_provider_tariff':"WhatsApp service providers tariffication",
    'menu_item_whatsapp_mo_routing':"Incoming message routing",
    'menu_item_statistics_whatsapp_inbound_detail':"Incoming WhatsApp messages detail statistics",
    'menu_item_statistics_whatsapp_inbound_group':"Group incoming WhatsApp statistics",
    'menu_item_mail_notify': 'Mail Notify',
    'menu_item_mail_notify_templates': 'Templates',
    'menu_item_mail_notify_external_templates': 'Operators templates Mail Notify',
    'menu_item_statistics_mail_notify_detail': 'Mail Notify detail statistics',
    'menu_item_statistics_mail_notify_group': 'Mail Notify group statistics',
    'menu_item_mail_notify_external_services': 'Operators services Mail Notify',
    'menu_item_mail_notify_clients_tariff': 'Mail Notify clients tariffication',
    'menu_item_mail_notify_provider_tariff': 'Mail Notify service providers tariffication',
    'menu_item_statistics_whatsapp_mo_detail':"Incoming WhatsApp messages detail statistics",
    'menu_item_statistics_whatsapp_mo_group':"Group incoming WhatsApp statistics",
    'menu_item_custom': "Custom",
    'menu_item_custom_templates': "Templates",
    'menu_item_statistics_custom_detail': "Custom detail statistics",
    'menu_item_statistics_custom_group': "Custom group statistics",
    'menu_item_custom_clients_tariff': "Custom clients tariffication",
    'menu_item_custom_provider_tariff': "Custom service providers tariffication",
    'menu_item_custom_mo_routing': "Incoming message routing",
    'menu_item_statistics_custom_inbound_detail': "Detailed incoming Custom statistics",
    'menu_item_statistics_custom_inbound_group': "Group incoming Custom statistics",
    "menu_item_tools": "Tools",
    "menu_item_tools_message_forwarding": "Resending Messages",
    "menu_item_sms_mo_routing": "Inbound routing",
    "menu_item_finance_balances": "Balance management",
    "menu_item_finance_overdrafts": "Client balances",
    "menu_item_settings_message_categories":"Message categories",
    'menu_item_settings_quantity_limits':'Message quantity limits',
    'menu_item_contacts_black_lists':'Black lists',
    'menu_item_settings_white_list': 'White list',
    'menu_item_settings_proxy':'Proxy settings',
    'menu_item_push_applications_groups': 'Application groups',
    'menu_item_push_subscribers_management': 'Subscriber management',
    'menu_item_push_devices_management': 'Application management',
    'menu_item_statistics_cdp_events_detail': 'CDP-events detail statistics',
    'menu_item_statistics_cdp_events_group': 'CDP-events group statistics',
    'menu_item_cdp_settings_cdp_client_attributes_managing': 'Managing CDP client attributes',
    'menu_item_cdp_settings_cdp_event_attributes_managing': 'Managing CDP event attributes',
    'menu_item_cdp_settings_cdp_client_condition_groups': 'CDP client conditional groups',
    'menu_item_cdp_settings_cdp_event_condition_groups': 'CDP event conditional groups',
    'menu_item_cdp_settings_cdp_scenario_managing': 'Managing CDP scenarios',
};

export default pages;
